export const NOTIFICA = 'NOTIFICA'
export const CARREGA = 'CARREGA'
export const LOGA = 'LOGA'

export const DEFINE_MODULOS = 'DEFINE_MODULOS'

export const CONFIGURACAO_SAF = 'CONFIGURACAO_SAF'